import FDictionary from '../__select';
import Form from './Form';

export default class FDictionaryShip extends FDictionary {
  dictionary = 'ship';

  permissionAdd = [115];

  addForm() {
    const item = new Form();
    item.init()
      .then();
    return item;
  }
}
